__turbopack_context__.v({
  "consent": "SubscribeForm-module__5Lr3EG__consent",
  "done": "SubscribeForm-module__5Lr3EG__done",
  "doneBody": "SubscribeForm-module__5Lr3EG__doneBody",
  "doneTitle": "SubscribeForm-module__5Lr3EG__doneTitle",
  "entry": "SubscribeForm-module__5Lr3EG__entry",
  "form": "SubscribeForm-module__5Lr3EG__form",
  "formColumn": "SubscribeForm-module__5Lr3EG__formColumn",
  "inline": "SubscribeForm-module__5Lr3EG__inline",
  "inlineDone": "SubscribeForm-module__5Lr3EG__inlineDone",
  "intro": "SubscribeForm-module__5Lr3EG__intro",
  "lede": "SubscribeForm-module__5Lr3EG__lede",
  "pitchSlot": "SubscribeForm-module__5Lr3EG__pitchSlot",
  "submit": "SubscribeForm-module__5Lr3EG__submit",
  "title": "SubscribeForm-module__5Lr3EG__title",
});
